import { OperationsListView, } from "./OperationsListView.tsx";
import { useModeratorStore, } from "../../../store/moderatorStore.ts";

export interface IOperationsListModerator {
  emptyBlockVariant?: "default" | "tiny";
}

export function OperationsListModerator({ emptyBlockVariant = "default", }: IOperationsListModerator,) {
  const operations = useModeratorStore(state => state.operations,);

  return (
    <OperationsListView
      isLoading={false}
      isSuccess={true}
      data={operations}
      cursorType="default"
      emptyBlockVariant={emptyBlockVariant}
    />
  );
}
